const TeamTab = {
    LOGO: 0
}

export default TeamTab;